import * as icons from '@sloyd/icons';
import styled from 'styled-components';

const modes = ['taper', 'tilt', 'slant', 'scale'];

export function WacomModes(props: any) {
  const { mode } = props;

  function onNudge(delta: number) {
    const index = modes.indexOf(mode);
    const newIndex = Math.max((index + delta) % modes.length, 0);
    const newMode = modes[newIndex];
    props.onModeChange(newMode);
  }

  function onArrowLeft() {
    onNudge(-1);
  }

  function onArrowRight() {
    onNudge(1);
  }

  return (
    <Wrapper>
      <Arrow onClick={onArrowLeft}>
        <icons.IconChevronLeft />
      </Arrow>
      <Text onClick={onArrowRight}>{mode}</Text>
      <Arrow onClick={onArrowRight}>
        <icons.IconChevronRight />
      </Arrow>
    </Wrapper>
  );
}

export const Wrapper = styled.div`
  border: 1px solid #fff;
  color: #fff;
  opacity: 0.2;
  background-color: var(--panels-bk-color);
  text-transform: uppercase;
  font-weight: bold;
  text-align: center;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
  border-radius: 10px;
  height: 25px;
  line-height: 25px;
  cursor: pointer;

  &:hover {
    background-color: #555;
  }
`;

export const Text = styled.div`
  flex: 1;
  font-size: 14px;
`;

export const Arrow = styled.div`
  position: relative;
  top: 3px;
`;
